import { ErrorType } from '../consts.js';
import { BaseError } from '../errors/BaseError.js';
import { ContextClassBase } from './RuntimeContext.js';

class InboxType extends ContextClassBase {
    // use to check params
    // invoke in building request
    isValidInbox(input) {
        if (input === undefined) {
            return false;
        }
        if (this.getContext().option.acceptIncorrectInboxType) {
            return true;
        }
        return this.getInboxTypeArray().includes(input);
    }
    // use to check params
    needSpecifyInbox() {
        const raw = this.ctx.option.inboxType;
        // allow undefined and number value (undefined will use default inbox)
        if (raw === undefined || (typeof raw === 'number' && raw >= 0)) {
            return false;
        }
        // if user option contains more than 1 inbox, should be specified
        if (Array.isArray(raw) && raw.length > 2) {
            return true;
        }
        // a backup option, should not go into this condition...
        return false;
    }
    // return the first inbox in InboxType array
    // be careful to use this, make sure you don't care about inbox
    getDefaultInboxWithoutCheck() {
        return this.getInboxTypeArray()[0];
    }
    // invoke in api, only need when user inbox is undefined and can't be calculated
    // in most case, use this to get a fallback inbox
    getDefaultInbox() {
        if (this.needSpecifyInbox()) {
            throw new BaseError({
                ctx: this.ctx,
                msg: 'no available inboxType is provided',
                type: ErrorType.InvalidInboxType,
                sender: this
            });
        }
        return this.getDefaultInboxWithoutCheck();
    }
    getInboxTypeArray() {
        const raw = this.ctx.option.inboxType;
        if (Array.isArray(raw)) {
            return raw;
        }
        else if (raw !== undefined) {
            return [raw];
        }
        else {
            return [0];
        }
    }
}

export { InboxType };
//# sourceMappingURL=InboxType.js.map
